function initCarousel() {
  const track = document.querySelector(".custom-upsell-track");
  const slides = Array.from(track.children);
  const nextButton = document.querySelector("#upsell-carousel-next-button");
  const prevButton = document.querySelector("#upsell-carousel-prev-button");

  let isDragging = false;
  let startPos = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID = 0;
  let currentIndex = 0;
  let intervalId = null;

  // Configuration option for auto-slide
  const autoSlideInterval = 4000; // Time in milliseconds between slides
  let isAutoSliding = false; // Set to false if you don't want auto-sliding by default

  // Function to start auto-sliding
  function startAutoSlide() {
    if (intervalId === null && isAutoSliding) {
      intervalId = setInterval(nextSlide, autoSlideInterval);
    }
  }

  // Function to stop auto-sliding
  function stopAutoSlide() {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  // Prevent default behavior on images
  slides.forEach((slide) => {
    const img = slide.querySelector("img");
    if (img) img.addEventListener("dragstart", (e) => e.preventDefault());
  });

  // Touch events
  track.addEventListener("touchstart", touchStart);
  track.addEventListener("touchend", touchEnd);
  track.addEventListener("touchmove", touchMove);

  // Mouse events
  track.addEventListener("mousedown", touchStart);
  track.addEventListener("mouseup", touchEnd);
  track.addEventListener("mouseleave", touchEnd);
  track.addEventListener("mousemove", touchMove);

  function nextSlide() {
    if (currentIndex < slides.length - 1) {
      currentIndex++;
    } else {
      currentIndex = 0;
    }
    setPositionByIndex();
  }

  function prevSlide() {
    if (currentIndex > 0) {
      currentIndex--;
    } else {
      currentIndex = slides.length - 1;
    }
    setPositionByIndex();
  }

  // Modified button click handlers
  if (nextButton) {
    nextButton.addEventListener("click", () => {
      stopAutoSlide(); // Stop auto-sliding when manually navigating
      nextSlide();
      startAutoSlide(); // Restart auto-sliding after manual navigation
    });
  }

  if (prevButton) {
    prevButton.addEventListener("click", () => {
      stopAutoSlide(); // Stop auto-sliding when manually navigating
      prevSlide();
      startAutoSlide(); // Restart auto-sliding after manual navigation
    });
  }

  function touchStart(event) {
    stopAutoSlide(); // Stop auto-sliding when user interacts
    isDragging = true;
    startPos = getPositionX(event);
    animationID = requestAnimationFrame(animation);
    track.classList.add("grabbing");
  }

  function touchEnd() {
    isDragging = false;
    cancelAnimationFrame(animationID);
    track.classList.remove("grabbing");

    const movedBy = currentTranslate - prevTranslate;

    if (Math.abs(movedBy) > 100) {
      if (movedBy < 0) {
        currentIndex += 1;
      } else {
        currentIndex -= 1;
      }
    }

    currentIndex = Math.max(0, Math.min(currentIndex, slides.length - 1));
    setPositionByIndex();
    startAutoSlide(); // Restart auto-sliding after user interaction
  }

  function touchMove(event) {
    if (!isDragging) return;

    const currentPosition = getPositionX(event);
    currentTranslate = prevTranslate + currentPosition - startPos;
  }

  function getPositionX(event) {
    return event.type.includes("mouse")
      ? event.pageX
      : event.touches[0].clientX;
  }

  function animation() {
    setSliderPosition();
    if (isDragging) requestAnimationFrame(animation);
  }

  function setSliderPosition() {
    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  function setPositionByIndex() {
    const slideWidth = slides[0].offsetWidth;
    currentTranslate = currentIndex * -slideWidth;
    prevTranslate = currentTranslate;
    setSliderPosition();
  }

  // Set initial position and start auto-sliding if enabled
  setPositionByIndex();
  startAutoSlide();

  // Window resize handler
  window.addEventListener("resize", setPositionByIndex);

  // Optional: Pause auto-sliding when the tab is not visible
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      stopAutoSlide();
    } else {
      startAutoSlide();
    }
  });
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", initCarousel);

